import React, { Component } from 'react';

const Venta = () => {
    return(
        <div>Área de Venta</div>
    );
}

export default Venta;
